

const bindValues = (el) => {
  console.log(el, 'bindValues');
  const selector = el.getAttribute('data-name');
  $(`span[data-size-name="${selector}"]`).html(el.value);
};


const showChart = (el) => {
    console.log(el, 'showChart');
  $('#size-chart').toggleClass('hide');
  return false;
};

$(document).ready( function (){
   $(document).on("click",".option2 input", function(){ 
    var value = $(this).attr("data-var");
	$(".size-form").addClass("hide");
    if(value == "custom"){
      $(".size-form").removeClass("hide");
    }    
  });
  
  $(document).on("click",".option1 input", function(){
    setTimeout(function(){
     var loop_index = 1;
     $(".option2").find(".swatch-element").each(function(index){
        var cls = $(this).attr("class");
       if(cls.indexOf("soldout")!=-1){   
       }else{
         if(loop_index == 1){
           $(this).find('input').trigger("change");
         }  
         loop_index++;
       }       
     });
    }, 500);
  });
  
});
//option2

/*

const hideForm = () => {
    const sizeForm = $('.size-form'); // getElementByClassName
    sizeForm.addClass('hide');
};
const showForm = () => {
  const sizeForm = $('.size-form');
  sizeForm.removeClass('hide');
};


const showCustomForm = (event) => {
//   event.stopPropagation();
//   if (event.cancelable) event.preventDefault();
  const isCustom = event.target.getAttribute('data-value') === 'custom';
  if(isCustom) showForm();
  else hideForm();
  return true;
};

let triggered = false;


$(document).ready( function (){
  

  
  $(document).on('click', '.tt-options-swatch', showCustomForm)

 
  /*
  if(!triggered) {
    setTimeout(
      function(){
        const customSwitch = $('.tt-options-swatch .active [data-value="custom"]');
        console.log(customSwitch)
		$('.tt-options-swatch').prop('onClick', 'showCustomForm()');
        triggered = true;
        const x = $(document).find('.tt-options-swatch .active [data-value="custom"]');
        if(x.length > 0) x.trigger('click');
      }, 3000);
  }
  
  
  
  
});

*/

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener('touchstart', handle, { passive: !ns.includes('noPreventDefault') });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener('touchmove', handle, { passive: !ns.includes('noPreventDefault') });
    }
};

/*


 setInterval(function(){ 
      
      var t =  $('.current_option_name').text();
   
   
   var url = window.location.href; 
   
   url = url.split('=');
   
   var variant_id = url[1];
        
        console.log('tett ' + variant_id)
        
        
        if(variant_id == '39667471646917')
        {
          $('.size-form').removeClass('hide');
        }
        else
        {
           $('.size-form').addClass('hide');
        }
   
   
                          
                          }, 500);

*/